import { render, staticRenderFns } from "./attachment-area.vue?vue&type=template&id=365996eb&"
import script from "./attachment-area.vue?vue&type=script&lang=js&"
export * from "./attachment-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports